import useFetchAgency from 'components/domain/agency/useFetchAgency';
import useAppUser from 'hooks/useAppUser';
import {
  IntegrationStatus,
  ConnectionConfigType,
  GetIntegrationAgencySettingsResponseTO,
} from 'models/InternalIntegrationSetting';

const useShouldRedirectToChannelsList = (
  isLoading: boolean,
  integrationAgencySettings?: GetIntegrationAgencySettingsResponseTO,
) => {
  const { agencyUid } = useAppUser();
  const { data: agency, isLoading: isLoadingAgency } = useFetchAgency({
    agencyUid: agencyUid as string,
  });

  const connectionConfigTypeNotAllowed =
    !isLoading &&
    integrationAgencySettings?.integration?.connectionConfig.type ===
      ConnectionConfigType.OUTBOUND_OAUTH;

  const isStatusNotAllowed =
    !isLoading &&
    integrationAgencySettings?.agencySettings?.status !==
      IntegrationStatus.ACTIVE;

  const isAgencyNotConfirmed =
    !isLoadingAgency && !!agency?.agencyConfirmed === false;

  const shouldRedirectToChannelsList =
    connectionConfigTypeNotAllowed ||
    isStatusNotAllowed ||
    isAgencyNotConfirmed;

  return shouldRedirectToChannelsList;
};

export default useShouldRedirectToChannelsList;
